<template>
  <transition name="page" mode="out-in">
    <slot>
      <transition>
        <router-view></router-view>
      </transition>
    </slot>
  </transition>
</template>

<script>
export default {
  name: "Child",
};
</script>
